import { Button } from 'react-bootstrap';
import { MdFullscreen } from 'react-icons/md';
import expandedViewConfig from '../../config/expandedView.config';

const ConnectedDevicesExpandedButton = ({ onClick }) => (
  <Button
    variant="primary"
    className="connected-devices-icon-button bg-primary border-primary text-white p-0 d-grid align-items-center justify-content-center"
    style={expandedViewConfig.buttonStyle}
    onClick={onClick}
    aria-label="Expand map and graph view"
    title="Expand map and graph view"
  >
    <MdFullscreen size={24} />
  </Button>
);

export default ConnectedDevicesExpandedButton;
